<div class="command-detail-state">
  <mat-icon class="command-detail-status-icon"
  [ngClass]="commandStatus?.iconColor">{{ commandStatus?.icon }}</mat-icon>
  <div class="command-detail-state-title"> {{ commandStatus.descriptionTransKey | transloco }} </div>
</div>
@if ((order.statusReason?.code && ( ('COMMAND.STATUSREASON.' + order.statusReason?.code?.toLocaleUpperCase()) | transloco )); as statusReason) {
  <div class="command-detail-statusreason flex-row justify-end align-stretch"
  >{{ statusReason }}</div>
}
